import { Component, OnInit } from '@angular/core';
import { PMSservice } from '../_services';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public logo_src = "https://www.ivldsp.com/wp-content/uploads/2018/07/IVL_Final_Logo-copy.png";
  public logo_href = "#";
  public logo_height = "45";
  
  public currentReviewPeriodName: string = '';
  public currentUserDetails: any;

  constructor(private PMSservice: PMSservice) { }

  ngOnInit() {
    this.loadReviewPeriodName();
  }

  loadReviewPeriodName() {
    this.PMSservice.getCurrentUserDetails().subscribe(res_user => {
      this.currentUserDetails = res_user;
      
      const det = { "status": "Active", "emp_id": this.currentUserDetails.id };
      this.PMSservice.getReviewPeriod(det).subscribe(res => {
        if (res && res['data'] && res['data'][0]) {
          this.currentReviewPeriodName = res['data'][0].name;
        }
      });
    });
  }
}
